<div class="customer_delete" id="actionsID">
  <mat-dialog-content>
    <!-- <div>
        <i type="button" data-bs-dismiss="modal" aria-label="Close" (click)="closeModel()"
    class="color-4 fs-2 far fa-times-circle position-absolute end-0 top-0 m-3"></i>
    </div> -->
    <div class="text-center pt-3">
      @if (msgFromDeal && !itemDelete) {
        <h2 class="text-1 fs-5 my-2">{{ titleMsg }}</h2>
      }
      @if (msgFromAgenda && !itemDelete) {
        <h2 class="text-1 fs-5 my-2">{{ titleMsg }}</h2>
      }
      <!-- <p *ngIf="itemDelete">{{titleMsgs}} </p> -->
      @if (itemDelete) {
        <p>
          {{ titleMsgs.split('(')[0].trim() }}
          <br />
          <span class="highlight-text"> ({{ extractedText }}) </span>
        </p>
      }

      @if (ItemsDeleteModule && !tableDelete && !titleMsgNew && !itemDelete) {
        <p>
          {{
            'QUOTE_TEMPLATE.Are You Sure You Want To Remove This Page'
              | translate
          }}
          {{ getTranslatedText('QUOTE_TEMPLATE.' + titleMsg) || '' }}
        </p>
      }
      @if (tableDelete && titleMsgNew && !itemDelete) {
        <p>
          {{ 'QUOTE_TEMPLATE.Do You Want To Remove This Table ?' | translate }}
        </p>
      }

      @if (
        !msgFromDeal &&
        !msgFromAgenda &&
        !ItemsDeleteModule &&
        !tableDelete &&
        !itemDelete
      ) {
        <p>{{ 'SYSTEM_USER.Invited Users deleted' | translate }}</p>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="d-flex flex-column align-items-center">
    <button
      class="btn btn-p-2 p-3 w-100 h5 shadow-sm rounded-pill mb-3"
      (click)="onConfirmClick()"
      tabindex="1"
    >
      {{ 'COMMON.YES' | translate }}
    </button>
    <button
      class="btn btn-cancel p-3 w-100 h5 shadow-sm rounded-pill"
      mat-dialog-close
      tabindex="-1"
    >
      {{ 'COMMON.Cancel' | translate }}
    </button>
  </mat-dialog-actions>
</div>
